var _templateObject;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable react/require-default-props */
import React from 'react';
import { node, string } from 'prop-types';
import styled from 'styled-components';
var StyledFaqAnswer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 28px;\n  color: #42484d;\n  padding-right: 26px;\n  margin-top: 0;\n  margin-bottom: 0;\n  width: 100%;\n"])));

var FaqAnswer = function FaqAnswer(_ref) {
  var children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      restProps = _objectWithoutProperties(_ref, ["children", "className"]);

  return /*#__PURE__*/React.createElement(StyledFaqAnswer, _extends({
    key: children,
    className: "scl-faq-answer ".concat(className)
  }, restProps), children);
};

FaqAnswer.propTypes = {
  /**
   Required and consists of everything between opening and closing tags when invoking component
  */
  children: node.isRequired,

  /**
   Optional className to include in rendered component
  */
  className: string
};
export default FaqAnswer;